export default {
  master_title: 'Mod brand - Meniu',
  title: 'Meniu',
  form: {
    has_internal_product_numbers: {
      label: 'Atribuire numere produse',
      tooltip: 'Atribuiți automat numere produselor în funcție de poziția lor în meniu. Numărul este tipărit pe bonuri',
    },
  },
  buttons: {
    new_menu: 'Meniu nou',
    export_menu: 'Exportare meniu',
    refresh: 'Reîmprospătare',
  },
  modals: {
    delete_category: {
      title: 'Ștergeți {{name}}',
    },
    delete_products: {
      title: 'Ștergeți {{count}} produse?',
      description: '<strong>{{count}}</strong> va fi eliminat din meniu',
    },
  },
  toasts: {
    failed_to_load_data: 'Încărcarea datelor a eșuat',
    failed_to_delete_menu: 'Meniul nu a putut fi șters, vă rugăm încercați din nou',
    menu_got_deleted: 'Meniul a fost șters',
    failed_to_delete_category: 'Categoria nu a putut fi ștearsă, vă rugăm încercați din nou',
    category_got_deleted: 'Categoria a fost ștearsă',
    failed_to_delete_products: 'Produsele nu au putut fi șterse, vă rugăm încercați din nou',
    product_got_deleted_one: 'Produsul a fost șters',
    product_got_deleted_few: 'Produsele au fost șterse',
    product_got_deleted_other: 'Produsele au fost șterse',
    failed_to_generate_product_number: 'Ceva a mers greșit. Reîncărcați pagina și încercați din nou',
    menu_exported: 'Meniul a fost exportat',
    failed_to_export_menu: 'Exportarea meniului a eșuat',
  },
};
